<template>
  <div>
    <div class="search-wrapper">
      <div class="search-item">
        <span>地区：</span>
        <Select v-model="searchValue.area" style="width: 120px;">
          <Option v-for="depart in areaArr" :key="depart.id" :value="depart.name">{{depart.name}}</Option>
        </Select>
      </div>
      <div class="search-item">
        <span>标题：</span>
        <Input v-model="searchValue.articleTitle" style="width:200px;"></Input>
      </div>
      <div class="search-item">
        <span>类型：</span>
        <Select v-model="searchValue.articleType" style="width: 120px;">
          <Option :value="74166">招标公告</Option>
          <Option :value="74169">更正公告</Option>
          <Option :value="74168">结果公告</Option>
          <Option :value="74167">其他公告</Option>
          <Option :value="''">全部</Option>
        </Select>
      </div>
      <div class="search-item">
        <span>状态：</span>
        <Select v-model="searchValue.articleStatus" style="width: 120px;">
          <Option :value="0">待审核</Option>
          <Option :value="1">通过</Option>
          <Option :value="2">不通过</Option>
          <Option :value="''">全部</Option>
        </Select>
      </div>
      <Button @click="searchArticle" type="primary" style="margin-right:5px;">搜索</Button>
      <Button @click="batchExamine" type="primary" style="margin-right:5px;">批量通过</Button>
      <Button @click="articleExamineReport" type="primary">审核报表</Button>
    </div>
    <Table :data="articlesList" :columns="articlesColumns" @on-selection-change="selectChange"></Table>
    <Page :current="currentPage" style="margin-top:10px;" :total="totalArticles" show-elevator show-total @on-change="changePage"></Page>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'

export default {
  name: 'articlesTable',
  props: {
    headColumns: {
      type: Array,
      default: () => {
        return []
      }
    },
    operateColumns: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchValue: {
        area: '',
        articleTitle: '',
        articleType: '',
        articleStatus: ''
      },
      areaArr: [],
      columns: [
        {
          title: '地区',
          key: 'areas',
          width: 65
        },
        {
          title: '类别',
          key: 'projectType',
          width: 120
        },
        {
          title: '标题',
          key: 'title'
        },
        {
          title: '类型',
          width: 100,
          render: (h, params) => {
            let type = '未知'
            switch (params.row.ext2) {
              case '74166':
                type = '招标公告'
                break
              case '74169':
                type = '更正公告'
                break
              case '74168':
                type = '结果公告'
                break
              case '74167':
                type = '其他公告'
                break
            }
            return h('div', type)
          }
        }
      ],
      articlesList: [],
      currentPage: 1,
      totalArticles: 0,
      batchArticles: []
    }
  },
  async created() {
    this.getArticles(1, this.searchValue)
    let areaRep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (areaRep.data.success && areaRep.data.result.items.length > 0) {
      this.areaArr = areaRep.data.result.items
    }
  },
  computed: {
    articlesColumns() {
      return [...this.headColumns, ...this.columns, ...this.operateColumns]
    }
  },
  methods: {
    async getArticles(page, { area = '', articleTitle = '', articleType = '', articleStatus = '' }) {
      this.currentPage = page

      let areaFilter = area ? ` and a.areas=="${area}"` : ''
      let titleFilter = articleTitle ? ` and a.title.contains("${articleTitle}")` : ''
      let typeFilter = articleType ? ` and a.ext2=="${articleType}"` : ''
      let statusFilter = articleStatus||articleStatus===0 ? ` and a.status=="${articleStatus}"` : ''

      let filter = areaFilter + titleFilter + typeFilter + statusFilter

      filter += ' and a.isDispaly=="true"'

      filter = filter.slice(5)

      let rep = await ajax.get(requestUrls.articles.getPaged, {
        params: {
          filter: filter,
          sorting: 'a.creationTime desc',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.articlesList = rep.data.result.items
        this.totalArticles = rep.data.result.totalCount
      }
    },
    changePage(page) {
      this.getArticles(page, this.searchValue)
    },
    refreshArticles() {
      this.getArticles(this.currentPage, this.searchValue)
    },
    searchArticle() {
      this.getArticles(1, this.searchValue)
    },
    selectChange(selection) {
      // this.$emit('selectChange', selection)
      this.batchArticles = selection
    },
    batchExamine() {
      if (this.batchArticles.length === 0) {
        this.$Message.info('请先选择需要批量审核的公告')
        return
      }
      this.$Modal.confirm({
        title: '批量通过审核',
        content: '确定批量通过选中的公告？',
        onOk: async () => {
          this.$Spin.show()
          try {
            let batchArticles = []

            this.batchArticles.forEach(article => {
              batchArticles.push({
                id: article.id,
                status: 1,
                opinion: '通过',
                checkUser: this.$store.state.session.user.name
              })
            })

            let rep = await ajax.post(requestUrls.articles.ArticlesStatusUpdate, batchArticles)
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('操作成功')
              this.refreshArticles()
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    articleExamineReport() {
      window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B9879%5D%5B76ee%5D%5B516c%5D%5B544a%5D%5B5ba1%5D%5B67e5%5D%5B60c5%5D%5B51b5%5D%5B8868%5D%2FProjectCheck.cpt`)
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin-bottom: 10px;
  .search-item {
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
